import React from "react";
import "./PageFooter.css";

export const PageFooter = () => {
  return <footer>&copy; 2023</footer>;
};
